import {
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.q1u_1 = new (LinkedHashSetClassDesc())(eSerializer.x1m());
      }
      x1m() {
        return this.q1u_1;
      }
      r1u() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().x2();
      }
      s1u(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      t1u(_this__u8e3s4) {
        return this.s1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      u1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v1u(_this__u8e3s4) {
        return this.u1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      w1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().h3(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x1u(_this__u8e3s4) {
        return this.w1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      y1u(_this__u8e3s4, size) {
      }
      z1u(_this__u8e3s4, size) {
        return this.y1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      a1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.n2(element);
      }
      b1v(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE();
        return this.a1v(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.m1v_1 = new (ArrayListClassDesc())(element.x1m());
      }
      x1m() {
        return this.m1v_1;
      }
      r1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().u2();
      }
      n1v(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      t1u(_this__u8e3s4) {
        return this.n1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      o1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v1u(_this__u8e3s4) {
        return this.o1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      p1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().o2(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x1u(_this__u8e3s4) {
        return this.p1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      q1v(_this__u8e3s4, size) {
        return _this__u8e3s4.m8(size);
      }
      z1u(_this__u8e3s4, size) {
        return this.q1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      r1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.g5(index, element);
      }
      b1v(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE();
        return this.r1v(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.t1v_1 = new (HashSetClassDesc())(eSerializer.x1m());
      }
      x1m() {
        return this.t1v_1;
      }
      r1u() {
        return HashSet().la();
      }
      u1v(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      t1u(_this__u8e3s4) {
        return this.u1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      v1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v1u(_this__u8e3s4) {
        return this.v1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      w1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().ma(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x1u(_this__u8e3s4) {
        return this.w1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1v(_this__u8e3s4, size) {
      }
      z1u(_this__u8e3s4, size) {
        return this.w1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      x1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.n2(element);
      }
      b1v(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE();
        return this.x1v(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.a1w_1 = new (HashMapClassDesc())(kSerializer.x1m(), vSerializer.x1m());
      }
      x1m() {
        return this.a1w_1;
      }
      b1w(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      c1w(_this__u8e3s4) {
        return this.b1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d1w(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.q3().u1();
      }
      e1w(_this__u8e3s4) {
        return this.d1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r1u() {
        return HashMap().w8();
      }
      f1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.v2(), 2);
      }
      t1u(_this__u8e3s4) {
        return this.f1w(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      g1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v1u(_this__u8e3s4) {
        return this.g1w(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().l9(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x1u(_this__u8e3s4) {
        return this.h1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      i1w(_this__u8e3s4, size) {
      }
      z1u(_this__u8e3s4, size) {
        return this.i1w(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.p1w_1 = new (LinkedHashMapClassDesc())(kSerializer.x1m(), vSerializer.x1m());
      }
      x1m() {
        return this.p1w_1;
      }
      b1w(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      c1w(_this__u8e3s4) {
        return this.b1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d1w(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.q3().u1();
      }
      e1w(_this__u8e3s4) {
        return this.d1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r1u() {
        return LinkedHashMap().gc();
      }
      q1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.v2(), 2);
      }
      t1u(_this__u8e3s4) {
        return this.q1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      r1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v1u(_this__u8e3s4) {
        return this.r1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().ic(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x1u(_this__u8e3s4) {
        return this.h1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s1w(_this__u8e3s4, size) {
      }
      z1u(_this__u8e3s4, size) {
        return this.s1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.u1w_1 = kClass;
        this.v1w_1 = new (ArrayClassDesc())(eSerializer.x1m());
      }
      x1m() {
        return this.v1w_1;
      }
      w1w(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.w1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x1w(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      e1w(_this__u8e3s4) {
        return this.x1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().u2();
      }
      y1w(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      t1u(_this__u8e3s4) {
        return this.y1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      z1w(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.u1w_1);
      }
      v1u(_this__u8e3s4) {
        return this.z1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      a1x(_this__u8e3s4) {
        return ArrayList().o2(asList(_this__u8e3s4));
      }
      x1u(_this__u8e3s4) {
        return this.a1x((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b1x(_this__u8e3s4, size) {
        return _this__u8e3s4.m8(size);
      }
      z1u(_this__u8e3s4, size) {
        return this.b1x(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      c1x(_this__u8e3s4, index, element) {
        _this__u8e3s4.g5(index, element);
      }
      b1v(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE();
        return this.c1x(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      d1v(_this__u8e3s4) {
        return _this__u8e3s4.v2();
      }
      c1w(_this__u8e3s4) {
        return this.d1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      e1v(_this__u8e3s4) {
        return _this__u8e3s4.u1();
      }
      e1w(_this__u8e3s4) {
        return this.e1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.j1w_1 = keySerializer;
        this.k1w_1 = valueSerializer;
      }
      l1w(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().s2(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.v3_1;
        var last = progression.w3_1;
        var step_0 = progression.x3_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.m1w(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      h1v(decoder, builder, startIndex, size) {
        return this.l1w(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      m1w(decoder, index, builder, checkIndex) {
        var key = decoder.b1s(this.x1m(), index, this.j1w_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.f1s(this.x1m());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().s2(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.x4(key)) {
          var tmp_2 = this.k1w_1.x1m().t1p();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.a1s(this.x1m(), vIndex, this.k1w_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.b1s(this.x1m(), vIndex, this.k1w_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.c5(key, value);
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.m1w(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      g1v(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.x1m();
        var composite = encoder.l1t(descriptor, size);
        var iterator = this.e1w(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.r3();
          // Inline function 'kotlin.collections.component2' call
          var v = element.s3();
          var tmp = this.x1m();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.g1t(tmp, _unary__edvuaz, this.j1w_1, k);
          var tmp_0 = this.x1m();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.g1t(tmp_0, _unary__edvuaz_0, this.k1w_1, v);
        }
        composite.p1r(descriptor);
      }
      y1m(encoder, value) {
        return this.g1v(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.f1v_1 = elementSerializer;
      }
      g1v(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.x1m();
        var composite = encoder.l1t(descriptor, size);
        var iterator = this.e1w(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.g1t(this.x1m(), index, this.f1v_1, iterator.w1());
          }
           while (inductionVariable < size);
        composite.p1r(descriptor);
      }
      y1m(encoder, value) {
        return this.g1v(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      h1v(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().s2(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.i1v(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      i1v(decoder, index, builder, checkIndex) {
        this.b1v(builder, index, decoder.b1s(this.x1m(), index, this.f1v_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.g1s($this.x1m());
  $this.z1u(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      k1v(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.x1u(previous);
        var builder = tmp1_elvis_lhs == null ? this.r1u() : tmp1_elvis_lhs;
        var startIndex = this.t1u(builder);
        var compositeDecoder = decoder.o1r(this.x1m());
        if (compositeDecoder.e1s()) {
          this.h1v(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.f1s(this.x1m());
            if (index === -1)
              break $l$loop;
            this.j1v(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.p1r(this.x1m());
        return this.v1u(builder);
      }
      z1m(decoder) {
        return this.k1v(decoder, null);
      }
      j1v(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.i1v(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.i1v.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.e1x_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.x1m());
      }
      x1m() {
        return this.e1x_1;
      }
      f1x(_this__u8e3s4) {
        return _this__u8e3s4.g1x();
      }
      t1u(_this__u8e3s4) {
        return this.f1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      h1x(_this__u8e3s4) {
        return _this__u8e3s4.i1x();
      }
      v1u(_this__u8e3s4) {
        return this.h1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      j1x(_this__u8e3s4, size) {
        return _this__u8e3s4.k1x(size);
      }
      z1u(_this__u8e3s4, size) {
        return this.j1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      l1x(_this__u8e3s4) {
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o(toString(message));
      }
      e1w(_this__u8e3s4) {
        return this.l1x((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
      }
      m1x(_this__u8e3s4, index, element) {
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o(toString(message));
      }
      b1v(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE();
        return this.m1x(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      r1u() {
        return this.x1u(this.n1x());
      }
      q1x(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.e1x_1;
        var composite = encoder.l1t(descriptor, size);
        this.p1x(composite, value, size);
        composite.p1r(descriptor);
      }
      y1m(encoder, value) {
        return this.q1x(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      g1v(encoder, value) {
        return this.q1x(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return this.k1v(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      r1x(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.g1x() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.k1x(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.k1x.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
